<script lang="ts">
  import type { Toast } from 'svelte-french-toast';
  import toast_ from 'svelte-french-toast';

  export let toast: Toast & {
    props: { content: string; subtitle: string; onClick: () => void };
  };

  // define a custom onClick to call onClick and toast_.dismiss(toast.id)
  const onClick_ = async () => {
    await toast.props.onClick();
    toast_.dismiss(toast.id);
  };

  // Use this component in your app:
  // toast(RichContent, { props: { someProp: '⭐' }})
</script>

<div
  on:click={onClick_}
  on:keypress={onClick_}
  class="flex cursor-pointer flex-col p-1 hover:rounded-md hover:bg-gray-100"
  aria-roledescription="notification"
  role="button"
  tabindex="0"
>
  {toast.props.content}
  {#if toast.props.subtitle}
    <span class="text-xs text-gray-500">{toast.props.subtitle}</span>
  {/if}
</div>
